export const ExternalLink = (props) => {
    return (
        <>
            {!props.disabled ? (
                <a
                    onClick={props.onClick}
                    style={props.styles || {}}
                    href={props.to || '#'}
                    target="_blank"
                    title={props.title || ''}
                    rel="noreferrer"
                >
                    {props.children}
                </a>
            ) : (
                <div style={props.styles || {}} title={props.title || ''}>
                    {props.children}
                </div>
            )}
        </>
    );
};
